import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'
import { combine } from 'zustand/middleware'

interface SidebarInfo {
  isOpen: boolean
  activeSidebar: string
  lastActiveSidebar: string
}

const DEFAULT_SIDEBAR_INFO: SidebarInfo = {
  isOpen: false,
  activeSidebar: '',
  lastActiveSidebar: ''
}

const useSidebarStore = create(
  combine(DEFAULT_SIDEBAR_INFO, (set) => ({
    openSidebar: (sidebarName: string) => {
      set((state) => ({
        isOpen: true,
        activeSidebar: sidebarName,
        lastActiveSidebar: state.activeSidebar
      }))
    },
    closeSidebar: () => {
      set((state) => ({
        isOpen: false,
        activeSidebar: '',
        lastActiveSidebar: state.activeSidebar
      }))
    },
    toggleSidebar: (sidebarName: string) =>
      set((state) => ({
        isOpen: !state.isOpen,
        activeSidebar: state.isOpen ? '' : sidebarName,
        lastActiveSidebar: state.activeSidebar
      }))
  }))
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Sidebar Store', useSidebarStore)
}

export default useSidebarStore
